import { Layout } from "antd";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { setChatInfo } from "store/chatbot/action";
import ChatHeader from "./components/chatHeader";
import ChatSideBar from "./components/chatSideBar";

const { Content } = Layout;

const ChatLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sidebarItemRef = useRef(null);
  const [collapsed, setCollapsed] = useState(true);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const history = useSelector((state) => state?.chatbotReducer?.history);
  const historyLoading = useSelector(
    (state) => state?.chatbotReducer?.historyLoading
  );

  const chatId = useLocation().pathname;

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (sidebarItemRef.current) {
      sidebarItemRef.current.scrollTo(0, 0, { behavior: "smooth" });
    }
  }, [collapsed]);

  useEffect(() => {
    setCollapsed(true);
  }, [chatId]);

  const goBack = () => {
    navigate("/home");
  };

  const onCollapsedChange = () => {
    setCollapsed(!collapsed);
  };

  const onNewChatClick = () => {
    navigate(`/chatbot`);
    setCollapsed(true);
    dispatch(setChatInfo(null));
  };

  const handleChatClick = (id) => {
    navigate(`/chatbot/chat/${id}`);
    setCollapsed(true);
  };

  return (
    <Layout className=" bg-white ">
      <Layout className="bg-white">
        <ChatHeader onCollapsedChange={onCollapsedChange} goBack={goBack} />
        <Content onClick={() => windowWidth < 768 && setCollapsed(true)}>
          <Outlet />
        </Content>
      </Layout>
      <ChatSideBar
        collapsed={collapsed}
        data={history}
        handleChatClick={handleChatClick}
        windowWidth={windowWidth}
        onNewChatClick={onNewChatClick}
        sidebarItemRef={sidebarItemRef}
        chatId={chatId}
        historyLoading={historyLoading}
      />
    </Layout>
  );
};
export default ChatLayout;
